import React from "react";
import { HomeOutlined } from "@ant-design/icons";
import { HomePhoneProduct } from "../../../../../types/homePhone";

interface ProductImageProps {
  product: HomePhoneProduct;
}

const ProductImage: React.FC<ProductImageProps> = ({ product }) => (
  <div className="pd-image-wrap">
    {product.imageUrl ? (
      <img src={product.imageUrl} alt={product.name} className="pd-image" />
    ) : (
      <HomeOutlined className="pd-image-placeholder" aria-hidden="true" />
    )}
  </div>
);

export default ProductImage;
